<button *ngIf="hasItem" (click)="toggleAssign()" class="link">
  <cx-icon
          class="u-pointer"
          [type]="iconTypes.BLACK_ICON_DELETE"
          (click)="toggleAssign()">
  </cx-icon>
</button>
